
const DEFAULT_DRAWING = {shapes: [], showGrid: false};

const getWorkings = (workingsData) => workingsData.get('value');
const getWorkingsDrawing = (workingsData) => workingsData.get('drawing') || DEFAULT_DRAWING;
const getWorkingsImageId = (workingsData) => workingsData.get('imageId');
const getWorkingsCode = (workingsData) => workingsData.get('code') || '';

export {getWorkings, getWorkingsDrawing, getWorkingsImageId, getWorkingsCode}
